import { render, staticRenderFns } from "./house-move.vue?vue&type=template&id=08edd777&scoped=true&"
import script from "./house-move.vue?vue&type=script&lang=js&"
export * from "./house-move.vue?vue&type=script&lang=js&"
import style0 from "./house-move.vue?vue&type=style&index=0&id=08edd777&scoped=true&lang=css&"
import style1 from "./house-move.vue?vue&type=style&index=1&id=08edd777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08edd777",
  null
  
)

export default component.exports